// client/src/pages/LoginPage.jsx - Page de connexion
import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import Seo from '../components/Seo';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  
  const { login, user } = useContext(AuthContext);
  const navigate = useNavigate();
  
  // Rediriger si déjà connecté
  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError(null);
      await login(email, password);
      navigate('/dashboard');
    } catch (error) {
      setError(error.message);
    }
  };
  
  return (
    <>
      <Seo
        title="Connexion"
        description="Accédez à votre espace YAQAM pour retrouver vos plans de repas et vos recettes personnalisées."
        noindex
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "YAQAM",
            "url": (typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com',
            "logo": "https://www.yaqam.com/img/logo_color-min.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "contactType": "customer support",
              "email": "info@j7lab.com"
            }]
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Accueil",
                "item": (typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com'
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Se connecter",
                "item": ((typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com') + (typeof window !== 'undefined' ? window.location.pathname : '/login')
              }
            ]
          }
        ]}
      />
      <div className="max-w-md mx-auto">
      <h1 className="text-3xl font-bold mb-8 text-center text-[#2C3E50]">Connexion</h1>
      
      {error && (
        <div className="bg-red-100 text-red-800 p-4 rounded-lg mb-6 border border-red-200">
          {error}
        </div>
      )}
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100">
        <div className="p-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label
                htmlFor="email"
                className="block text-[#2C3E50] font-medium mb-2"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                required
              />
            </div>
            
            <div className="mb-6">
              <label
                htmlFor="password"
                className="block text-[#2C3E50] font-medium mb-2"
              >
                Mot de passe
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                required
              />
            </div>
            
            <div className="mb-6">
              <button
                type="submit"
                className="w-full py-3 bg-[#87A96B] text-white rounded-lg font-medium hover:bg-[#87A96B]/90 transition-colors shadow-md hover:shadow-lg"
              >
                Se connecter
              </button>
            </div>
            
            <div className="text-center text-gray-600">
              <p>
                Pas encore de compte?{' '}
                <Link
                  to="/register"
                  className="text-[#E67E22] hover:text-[#E67E22]/80 font-medium transition-colors"
                >
                  S'inscrire
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default LoginPage;
